import { render, staticRenderFns } from "./ContentEditableV2.vue?vue&type=template&id=6807167c"
import script from "./ContentEditableV2.vue?vue&type=script&lang=js"
export * from "./ContentEditableV2.vue?vue&type=script&lang=js"
import style0 from "./ContentEditableV2.vue?vue&type=style&index=0&id=6807167c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports